import { v4 as uuidV4 } from 'uuid';
import Storage from './storage';

const PENDO_AGENT_BASE_URL = 'https://content.pd-log.showpad.biz/agent/static';
const PENDO_SCRIPT_ID = 'pendo-agent-script';
const PENDO_VISITOR_ID_KEY = 'scv-pendoVisitorId';

let pendoAgentPromise = null;

const getOrCreateVisitorUuid = function () {
    return Storage.get(PENDO_VISITOR_ID_KEY)
        .catch(() => null)
        .then((storedUuid) => {
            if (storedUuid) {
                return storedUuid;
            }

            const uuid = uuidV4();
            return Storage.set(PENDO_VISITOR_ID_KEY, uuid)
                .catch(() => {})
                .then(() => uuid);
        });
};

const clearPendoVisitorId = function () {
    return Storage.remove(PENDO_VISITOR_ID_KEY).catch(() => {});
};

const loadPendoAgent = function (apiKey) {
    if (!pendoAgentPromise) {
        pendoAgentPromise = new Promise((resolve, reject) => {
            const listeners = new AbortController();
            const script = document.createElement('script');
            script.id = PENDO_SCRIPT_ID;
            script.async = true;
            script.src = `${PENDO_AGENT_BASE_URL}/${apiKey}/pendo.js`;

            script.addEventListener(
                'load',
                () => {
                    listeners.abort();
                    resolve();
                },
                { signal: listeners.signal },
            );
            script.addEventListener(
                'error',
                () => {
                    listeners.abort();
                    reject(new Error(`Failed to load the Pendo agent from ${script.src}`));
                },
                { signal: listeners.signal },
            );

            document.head.appendChild(script);
        });
    }

    return pendoAgentPromise;
};

const initializePendo = function (apiKey, environment, organisationId, persistVisitorId = false) {
    if (!apiKey) {
        return Promise.resolve();
    }

    const environmentPrefix = ['shared-eks-production', 'production'].includes(environment) ? 'production' : 'staging';

    const visitorUuidPromise = persistVisitorId ? getOrCreateVisitorUuid() : Promise.resolve(uuidV4());

    return visitorUuidPromise.then((uuid) =>
        loadPendoAgent(apiKey).then(() => {
            window['pendo'].initialize({
                visitor: {
                    id: `${environmentPrefix}-${organisationId}-showcase_client_${uuid}`,
                    isProspect: true,
                    environment: environment,
                    screenWidth: window.screen.width,
                    screenHeight: window.screen.height,
                },
                account: {
                    id: `${environmentPrefix}-${organisationId}`,
                },
                excludeAllText: true,
                disableCookies: true,
                disablePersistence: true,
            });
        }),
    );
};

export { initializePendo, clearPendoVisitorId };
